<script lang="ts">
  import { _ } from "svelte-i18n";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let prefix = "";
  export let primary = "";
  export let primaryLabel = "";
  export let secondary = "";
  export let secondaryLabel = "";
  export let selectedSwitchOption = primary;
  export let dark = false;

  const onOptionClick = (option: string) => {
    selectedSwitchOption = option;
  };
</script>

<style lang="scss">
  .switcher {
    display: flex;
    align-items: center;

    &--pipe {
      position: relative;
      transform: translateY(1.5px);
    }

    &--option {
      background: none;
      margin: 0;
      border: none;
      padding: 4px 8px 2px;

      &:last-child {
        padding-right: 0;
      }
    }
  }
</style>

{#if selectedSwitchOption === primary || selectedSwitchOption === secondary}
  <div class="switcher">
    {#if prefix !== ""}
      <div class="switcher--prefix">
        <Typography theme={`${dark ? "" : "inverse"}-on-surface`}
          >{$_(prefix)}:</Typography
        >
      </div>
    {/if}
    <button
      type="button"
      on:click={() => onOptionClick(primary)}
      class="switcher--option"
    >
      <Typography
        component="span"
        variant="button1"
        theme={selectedSwitchOption === primary
          ? `inverse-on-surface-60`
          : `${dark ? "" : "inverse-"}on-surface`}
      >
        {$_(primaryLabel ? primaryLabel : primary)}
      </Typography>
    </button>
    <span class="switcher--pipe">
      <Typography
        component="span"
        variant="body1-emphasise"
        theme={`inverse-on-surface`}>|</Typography
      >
    </span>
    <button
      type="button"
      on:click={() => onOptionClick(secondary)}
      class="switcher--option"
    >
      <Typography
        component="span"
        variant="button1"
        theme={selectedSwitchOption === secondary
          ? `inverse-on-surface-60`
          : `${dark ? "" : "inverse-"}on-surface`}
      >
        {$_(secondaryLabel ? secondaryLabel : secondary)}
      </Typography>
    </button>
  </div>
{/if}
